<p-panel [style]="{ 'margin-top': '1em' }" styleClass="panel-shadow">
  <p-header>
    <div class="panel-header">Odometer Readings</div>
  </p-header>

  <div [class.ghost]="!odometerTask">
    <div
      *ngIf="awaitingAllocation; else showDetails"
      class="py-3 text-center"
      style="font-weight: 500; color: #999"
    >
      Awaiting Allocation
    </div>

    <ng-template #showDetails>
      <div class="grid-label-3-value">
        <div class="vert-contents">Pick-up:</div>
        <div class="value vert-contents ghost-fill">
          {{ odometerTask?.pickupOdometer | number : '2.' }}mi
        </div>
        <div *ngIf="organisationTypeId == 1">
          <button
            pButton
            class="ui-button-secondary"
            label="Change"
            (click)="showOdometerReadingDialog(true)"
          ></button>
        </div>
      </div>

      <div style="border-top: 1px solid #dfdfdf; margin-top: 15px; padding-top: 15px"></div>

      <div class="grid-label-3-value">
        <div class="vert-contents">Drop-off:</div>
        <div class="vert-contents value ghost-fill">
          {{ odometerTask?.dropoffOdometer | number : '2.' }}mi
        </div>
        <div class="" *ngIf="organisationTypeId == 1">
          <button
            pButton
            label="Change"
            class="ui-button-secondary"
            (click)="showOdometerReadingDialog(false)"
          ></button>
        </div>
      </div>

      <div *ngIf="organisationTypeId == 1" class="mt-2">
        <div style="border-top: 1px solid #dfdfdf; margin-top: 15px; padding-top: 10px"></div>

        <div class="grid-label-2-value">
          <div>Estimated:</div>
          <div class="value ghost-fill">{{ odometerTask?.estimatedMiles.toFixed(1) }}mi</div>
        </div>

        <div class="grid-label-2-value">
          <div>Actual:</div>
          <div class="value ghost-fill">{{ odometerTask?.actualMiles }}mi</div>
        </div>

        <div class="grid-label-2-value">
          <div>
            <span *ngIf="odometerTask?.actualMiles < odometerTask?.estimatedMiles">Under</span>
            <span *ngIf="odometerTask?.actualMiles > odometerTask?.estimatedMiles">Over</span>
            :
          </div>
          <div class="value ghost-fill">{{ odometerTask?.milesDiff.toFixed(1) }}mi</div>
        </div>
      </div>
      <div *ngIf="organisationTypeId == 1">
        <div class="grid-label-2-value">
          <div>Percent %:</div>
          <div>
            <span class="value {{ displayRedAlert }} ghost-fill">
              {{ differencePercent.toFixed(1) }}%
            </span>
            (Estimated VS Actual)
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</p-panel>

<p-dialog
  [header]="(odometerEdited.isPickup ? 'Pick-Up' : 'Drop-Off') + ' Odometer Reading'"
  [(visible)]="isShownOdometerDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '350px' }"
>
  <div class="style2023 p-3">
    <div class="input-group">
      <div class="input-group-prepend white-space-nowrap">
        <span *ngIf="odometerEdited.isPickup">Pick-Up Odometer</span>
        <span *ngIf="!odometerEdited.isPickup">Drop-Off Odometer</span>
      </div>
      <div class="input-group-item">
        <input
          type="number"
          [(ngModel)]="odometerEdited.odometer"
          style="width: 100%"
          pInputText
          maxlength="7"
          min="0"
          max="9999999"
        />
      </div>
    </div>
    <div
      *ngIf="editedOdometerIsDropoffLessPickup"
      class="ui-messages-error ui-corner-all"
      style="padding: 0.25em 0.5em"
    >
      Drop-off odometer reading needs to be greater than pick-up reading
    </div>
  </div>
  <p-footer>
    <div class="text-right">
      <button
        type="button"
        (click)="isShownOdometerDialog = false"
        pButton
        label="Cancel"
        class="ui-button ui-button-tertiary"
      ></button>
      <button
        type="button"
        pButton
        label="Save"
        class="ui-button ui-button-primary"
        [disabled]="!editedOdometerValid"
        (click)="saveOdometerReading()"
      ></button>
    </div>
  </p-footer>
</p-dialog>
